import Vue from 'vue'
import Vuex from 'vuex'
import isMobile from 'is-mobile'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShowMergePicMode: false,
    isShowVideoMode: false,
    theme: 'black',
    isMobile: isMobile()
  },
  mutations: {

  },
  actions: {

  }
})
